module.exports = __webpack_public_path__ + "img/w1.65fabe98.png";